import * as zod from 'zod';

// This schema validates a string that fullfills this format: <tenant>\<consultantNumber>
const loggedInUserCookieSchema = zod.string().regex(/^[A-Za-z]{2}\\\d+$/);

/**
 * Validates the provided string against the loggedInUserCookie schema.
 *
 * @param cookieContent - The content of the logged-in user cookie to validate. It can be undefined.
 * @returns The validated logged-in user data if the validation is successful, otherwise `undefined`.
 */
export const validateLoggedInUserCookie = cookieContent => {
  const result = loggedInUserCookieSchema.safeParse(cookieContent);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
//# sourceMappingURL=validateLoggedInUserCookie.js.map